import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <span className="w-16 h-16 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center mb-6">
        <i className="ri-moon-foggy-line text-3xl"></i>
      </span>
      <p className="text-6xl md:text-8xl font-heading font-black text-primary-700 select-none">404</p>
      <h1 className="mt-4 text-xl md:text-2xl font-heading font-bold text-foreground-950">
        页面不存在或已删除
      </h1>
      <p className="mt-2 text-sm text-foreground-500 font-mono break-all max-w-md">{location.pathname}</p>
      <p className="mt-4 text-sm text-foreground-500 max-w-md">
        你访问的内容可能已被移动或移除。可以返回首页，或前往影视分类继续浏览。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="px-5 h-11 flex items-center gap-2 rounded-md bg-primary-600 text-background-50 text-sm hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="px-5 h-11 flex items-center gap-2 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          <i className="ri-apps-2-line"></i>
          影视分类
        </Link>
      </div>
    </div>
  );
}